export const Routes = {
  Root: '/',
  Home: 'home',
  // Oeffentliche, login-lose Kunden-Upload-Seite (Decision #126) — als eigene
  // Top-Level-Route ohne ProtectedRoute/Shell im Router eingehaengt.
  Unterlagen: 'unterlagen',
  // Oeffentliche, login-lose Kunden-Self-Service-Seiten (Decision #65):
  // /termin/:meetingId/absagen und /termin/:meetingId/umbuchen. Ebenfalls als
  // eigene Top-Level-Routen ohne ProtectedRoute/Shell eingehaengt.
  Termin: 'termin',
  // Oeffentliche, login-freie Buchungsseite pro Pool (Stufe 1, Entscheide Alex
  // E1-E6 vom 04.08.2026): /buchen/:slug?source=… — ebenfalls Top-Level ohne
  // ProtectedRoute/Shell. `slug` ist der OEFFENTLICHE Pool-Slug.
  Buchen: 'buchen',
  Auth: 'auth',
  SignIn: 'sign-in',
  ResetPasswordEmail: 'reset-password-email',
  ResetPasswordSuccess: 'reset-password-success',
  PasswordReset: 'password-reset',
  ForgotPassword: 'forgot-password',
  Cockpit: 'cockpit',
  Admin: 'admin',
  Customers: 'customers',
  Customer: 'customer',
  CustomerDetails: 'customer-details',
  LifePlan: 'life-plan',
  LifeRoad: 'life-road',
  LifeRoadAnalytics: 'life-road-analytics',
  Estg: 'estg',
  HousePayment: 'house-payment',
  Planner: 'planner',
  BSC: 'bsc',
  KLV: 'klv',
  LifeInsurance: 'life-insurance',
  Finance: 'finance',
  FinanceInfo: 'finance-info',
  Funding: 'funding',
  Savings: 'savings',
  Calculator: 'calculator',
  HealthInsuranceAnalysis: 'health-insurance-analysis',
  Diagram: 'diagram',
  Children: 'children',
  Concept: 'concept',
  ConceptInsurance: 'insurance',
  Household: 'household',
  HouseholdCalculator: 'household-calculator',
  RetirementClient: 'retirement-client',
  Documents: 'documents',
  DocumentsTable: 'documents-table',
  ComparisonCalculator: 'comparison-calculator',
  DebtFreeCalculator: 'debt-free-calculator',
  Teams: 'teams',
  UsersTeams: 'users-teams',
  MailTemplates: 'mail-templates',
  ApplicationAdmin: 'application-admin',
  ApplicationTypes: 'application-types',
  ApplicationProviders: 'application-providers',
  ApplicationVpFields: 'application-vp-fields',
  ApplicationTemplates: 'application-templates',
  Deals: 'deals',
  CaseDetail: 'cases/:id',
  Meetings: 'meetings',
  MeetingPools: 'meeting-pools',
  ApiKeys: 'api-keys',
  Notifications: 'notifications',
  Todos: 'todos',
  CustomerDetail: 'customers/:id',
  GoogleOAuthComplete: 'google-oauth-complete',
  Callcenter: 'telefonie',
  Calendar: 'calendar',
  Dashboard: 'dashboard',
  ActivityLog: 'activity-log',
  Segments: 'segments',
  Neuigkeiten: 'neuigkeiten',
  // Read-only-Renderer der Prozessdoku fuer Admins (nur SA, role:sa im BE) —
  // docs/tasks/prozessdoku-admin-ui.md.
  Prozesse: 'prozesse',

  Controlling: 'controlling',
  Lernplattform: 'lernplattform',
  Sprechstunden: 'sprechstunden',
  // Ansprechpartnerliste, Ziel der Dashboard-Kachel (Decision #237).
  Organigramm: 'organigramm',
  KiTrainer: 'ki-trainer',
};

export const CompanyRoute = 'https://softverysolutions.com';
